import { Ng2StateDeclaration } from '@uirouter/angular';
import { RoleShareContentComponent } from '../role-share-content/role-share-content.component';
import { FiRoleStateResolveRole } from './resolve/role';
import { FiRoleStateResolveAllRoles } from './resolve/all-roles';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { AppTextService } from '@fi-shared/app-text';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiRoleShareContentState: Ng2StateDeclaration = {
    name: FiStateNames.Role.ShareContent,
    url: '/:Id/ShareContent',
    views: {
        '@': {
            component: RoleShareContentComponent,
        },
    },
    resolve: {
        role: FiRoleStateResolveRole,
        allRoles: FiRoleStateResolveAllRoles,
        pageTitle: [PageTitleService, AppTextService, 'role', FiRoleShareContentStateResolve_pageTitle],
    },
};

export function FiRoleShareContentStateResolve_pageTitle(
    ccmPageTitle: PageTitleService,
    appTextService: AppTextService,
    role,
) {
    return ccmPageTitle.setTitle(appTextService.get('role.share_existing_content') + ': ' + role.Name);
}
